<template>
    <div>
        <el-dialog
            :title="$t('trainingVideo')"
            visible
            class="img-des-dialog"
            width="62%"
            @close="onCancel">
            <div class="img-des-cls">
                <div class="block" v-for="index in 3" :key="index">
                    <div class="title-cls" v-html="index == 1 ? imgTitle1 : index == 2 ? imgTitle2 : imgTitle3"/>
                    <el-image :src="index == 1 ? img1 : index == 2 ? img2 : img3" fit="fill" @click="chooseVideo(index)"
                              class="img-cls">
                        <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title=""
            class="video-player-cls"
            :visible.sync="videoDisplay"
            :close-on-click-modal="false"
            append-to-body
            width="62%"
            :before-close="handleCloseVideo">

            <video width="100%" controls id="video" oncontextmenu="return false" controlslist="nodownload"
                   v-if="videoDisplay" autoplay>
                <source :src="video" type="video/mp4">
                您的浏览器不支持 video 标签。
            </video>
            <div class="video-mask">
                {{ $t('head_video_mask') }}
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: "shortVideos",
        props: {
            onCancel: Function,
        },
        data() {
            return {
                videoDisplay: false,
                imgTitle1: `KCC视频简介<br>KCC short introduction`,
                imgTitle2: `快速登录KCC<br>Login to KCC`,
                imgTitle3: `上传审计资料(PBC)<br>Upload PBC information`,
                img1: require('@/assets/img/kcc-short-introduction.jpg'),
                img2: require('@/assets/img/login-to-kcc.jpg'),
                img3: require('@/assets/img/upload-pbcs.jpg'),
                video: null,
                cn: require('@/assets/videos/kcc-short-introduction-cn-new.mp4'),
                en: require('@/assets/videos/kcc-short-introduction-en-new.mp4'),
                yueyu: require('@/assets/videos/kcc-short-introduction-yueyu-new.mp4'),
                video2: require('@/assets/videos/login-to-kcc.mp4'),
                video3: require('@/assets/videos/upload-pbcs.mp4'),
            }
        },
        created() {
            Vue.prototype.$chooseVideo = (index, showPBCMask = false, lang) => {
                this.chooseVideo(index, showPBCMask, lang)
            }
        },
        methods: {
            chooseVideo(index, showPBCMask = false, lang ) {
                switch (index) {
                    case 1:
                        this.video = lang?this[lang]:this.$i18n.locale === 'zh' ? this.cn:this.en;
                        break;
                    case 2:
                        this.video = this.video2;
                        break;
                    case 3:
                        this.video = this.video3;
                        break;
                }
                this.videoDisplay = true

                this.$nextTick(() => {
                    if (showPBCMask) {
                        document.querySelector('.video-mask').style.opacity = 1
                        setTimeout(() => {
                            document.querySelector('.video-mask').style.opacity = 0
                            setTimeout(() => {
                                document.querySelector('.video-mask').style.display = 'none'
                            }, 1000);
                        }, 3000)
                    } else {
                        document.querySelector('.video-mask').style.display = 'none'
                    }
                })
            },
            handleCloseVideo() {
                this.videoDisplay = false
                if (localStorage.getItem('homepage_video_close_all') == 1) {
                    localStorage.removeItem('homepage_video_close_all')
                    this.$hideVideoDialog()
                }
            }
        }
    }
</script>

<style scoped>
.img-des-dialog ::v-deep .el-dialog .el-dialog__body{
    padding: 15px;
}
.img-des-cls{
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.block{
    width: 30%;
}
.img-cls{
    cursor: pointer;
    height: 176px;
    width: 100%;
}
.title-cls{
    color: rgb(63, 72, 204);
    font-size: 15px;
    font-weight: bold;
}
.video-player-cls ::v-deep .el-dialog{
    background-color: rgba(255,255,255,0);
}
 .video-player-cls ::v-deep .el-dialog .el-dialog__header,
 .video-player-cls ::v-deep .el-dialog .el-dialog__body{
    padding: 0 !important;
     border-bottom: none;
}
 .video-player-cls ::v-deep .el-dialog .el-dialog__header .el-dialog__headerbtn{
     top: -20px;
     right: -20px;
     border: 1PX solid #fff;
     border-radius: 50%;
 }
 .video-player-cls ::v-deep .el-dialog .el-dialog__header  .el-dialog__headerbtn .el-dialog__close{
     color: #fff;
 }
 @font-face{
    font-family: 'KPMG-Extralight';
    src: url('/KPMG-Extralight.ttf'),
}
 .video-mask {
    width: 100%;
    height: 100%;
    background-color: #0091da;
    color: white;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 1.5em;
    transition: opacity 1s linear;
    font-family: KPMG-Extralight;
 }
</style>